import React from "react";

import { ProductCard } from "@/components/ProductCard";
import SubcategoriesGrid from "@/components/SubcategoriesGrid";
import { ProductCategoryPageProductProps } from "@/pages/nettbutikk/[categorySlug]";

export type ProductsFullListProps = {
  className?: string;
  products: ProductCategoryPageProductProps[];
  title?: string;
};

export const ProductsFullList = ({
  className,
  products,
}: ProductsFullListProps) => {
  return (
    <SubcategoriesGrid className={className}>
      {products?.map((product) => (
        <ProductCard product={product} key={product.skuCode} />
      ))}
    </SubcategoriesGrid>
  );
};

export default ProductsFullList;
